
import { SET_CATEGORIES } from "./types";
export const setCategories = (categories: any[]) => ({
    type: SET_CATEGORIES,
    payload: categories
});